export default __webpack_public_path__ + "static/media/form-background.8f3c4957.jpg";